export default "__VITE_ASSET__VHOAlDng__"